import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { trackPageView } from './track';

/**
 * Mount once inside the router. Fires an anonymous page-view beacon on every
 * navigation. Renders nothing.
 */
export function Analytics() {
  const location = useLocation();
  const { i18n } = useTranslation();

  useEffect(() => {
    trackPageView(location.pathname, i18n.language || 'ka');
  }, [location.pathname, i18n.language]);

  return null;
}
